/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */


/**
* AWS-specific vault configuration. 
*/
export class AwsVaultConfigInput {
  /**
  * ARN of the KMS key used for encryption. Omitted if the key is managed by Eon. 
  */
  'encryptionKey'?: string;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "encryptionKey",
      "baseName": "encryptionKey",
      "type": "string",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return AwsVaultConfigInput.attributeTypeMap;
  }

  public constructor() {
  }
}

